const initialState = {
  reports: [],
  embedToken: {},
  activeReport: {},
  busy: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_HIGHLIGHTS/POPULATE_REPORT_LIST':
      return {
        ...state,
        reports: action.data,
        activeReport: action.data && action.data.length && action.data[0],
      };
    case 'ANALYTICS_HIGHLIGHTS/POPULATE_EMBED_TOKEN':
      return {
        ...state,
        embedToken: action.data,
      };
    case 'ANALYTICS_HIGHLIGHTS/POPULATE_ACTIVE_REPORT':
      return {
        ...state,
        activeReport: action.data,
      };
    case 'ANALYTICS_HIGHLIGHTS/POPULATE_BUSY':
      return {
        ...state,
        busy: action.data,
      };
    default:
      return state;
  }
};
